import { getUser } from 'localStorage/authStorage';
import { getCity } from 'localStorage/cityStorage';
import moment from 'moment';

export const momentLocal = (date?: moment.MomentInput) => {
	let offset = 360;
	const cities = getCity();
	const user = getUser();
	if (user?.company?.city && cities?.length) {
		const city = cities.find((cit) => cit._id === user.company.city);
		if (city?.utcOffset !== undefined) {
			offset = city.utcOffset;
		}
	}
	return moment.utc(date).utcOffset(offset);
};

export const formatCalendarDate = (
	date?: moment.MomentInput,
	format = 'DD/MM/YYYY',
) => moment.utc(date).format(format);

const isValidDateObject = (value: Date | string) => {
	// eslint-disable-next-line no-restricted-globals
	return value instanceof Date && !isNaN(value.getTime());
};

export const formatDate = (
	_date: Date | string,
	timeZone = 'America/Mexico_City',
) => {
	let date = new Date();
	if (isValidDateObject(_date)) {
		date = _date as Date;
	} else {
		date = new Date(_date);
	}

	const formatter = new Intl.DateTimeFormat('en-US', {
		timeZone,
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
		hour: '2-digit',
		minute: '2-digit',
		second: '2-digit',
		hour12: true,
	});
	return formatter.format(date).split(',')[0];
};

export const formatHour = (
	_date: Date | string,
	timeZone = 'America/Mexico_City',
) => {
	let date = new Date();
	if (isValidDateObject(_date)) {
		date = _date as Date;
	} else {
		date = new Date(_date);
	}

	const formatter = new Intl.DateTimeFormat('en-US', {
		timeZone,
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
		hour: '2-digit',
		minute: '2-digit',
		second: '2-digit',
		hour12: true,
	});
	return formatter.format(date).split(',')[1].replace(':00 ', ' ');
};
